export default "__VITE_ASSET__DNB3AHZ6__"